import { getConstanceSettings } from '@disco/state-management/selectors/user'

import { useSelector } from 'hooks/use-redux'

export const useAppearsOnEnabled = (): boolean => {
  const constanceSettings = useSelector(getConstanceSettings)
  return Boolean(constanceSettings?.APPEARS_ON)
}
